package game.ui;

import data.Parts.PartDef;
import cerastes.ui.AdvancedText;
import h2d.Object;
import cerastes.SoundManager;
import cerastes.Utils;
import cerastes.fmt.CUIResource.CUIEntity;
import cerastes.c2d.Vec2;
import h2d.Interactive;
import cerastes.ui.Button;
import cerastes.fmt.CUIResource.CUIObject;
import cerastes.ui.UIEntity;
#if tools
import cerastes.tools.ImguiTool.ImGuiToolManager;
import imgui.ImGuiMacro.wref;
import imgui.ImGui;
import cerastes.tools.ImguiTools.IG;
#end

@:structInit class UITrashDef extends CUIObject
{
}

@:build(cerastes.macros.Callbacks.CallbackGenerator.build())
@:build(cerastes.macros.UIEntityBuilder.build( UITrashDef ))
class UITrash extends UIEntity
{
	#if tools
	@:keep public static function getInspector( def: UITrashDef ) {
	}
	#end

	@:obj public var intTrash: Interactive;

	@:callbackStatic
	public static function onPartDropped( );

	public override function initialize( root: h2d.Object )
	{
		//removeChildren();
		//root = hxd.Res.ui.part_slot.toObject(this);

		cerastes.macros.UIPopulator.populateObjects();
		super.initialize(root);
	


	}

	public function setPartAccepted( p: PartDef )
	{

	}

	override function tick( d: Float )
	{
		if( intTrash == null )
			return;

		var bounds = getBounds();

		var dp: UIPart = Std.downcast(UIEntity.draggingEntity, UIPart);
		if( dp == null )
			return;

		if( !dp.generic)
			return;


	
		var p: Vec2 = {x: bounds.xMin + intTrash.width / 2, y: bounds.yMin + intTrash.height / 2 };
		dp.setDragValid( queryDragPoint( p, game.ui.UITypes.DragKey.Part ) );
	


	}

	override function onDrop( other: UIEntity )
	{
		if( GameState.data.day == 1 && GameState.get("tutorial_phase") == 6 )
		{
			var dp: UIPart = Std.downcast(other, UIPart);
			if( dp.defective )
				GameState.flow.jumpFile("data/day1.flow", "repair_day1_2");
			else 
				GameState.flow.jumpFile("data/day1.flow","repair_day1_1_b");
		}

		other.remove();
	}

}